window.jQuery = require('jquery');
require('angular');
require('angular-ui-router');
require('angular-ui-router/release/stateEvents');
require('angular-ui-router-tabs');
require('angular-cookies');
require('angular-ui-bootstrap');
require('ng-infinite-scroll');
require('angularFileUpload');
require('angular-resource');
require('angular-sanitize');
require('angular-ui-mask');
require('angular-ui-validate');
require('localize');
require('istevenMultiSelect');
require('moment');
require('daterangepicker');
require('jqueryPlaceholder');
require('angular-clipboard');
require('angular-css');

// Chart.js for metrics visualization in admin console
window.Chart = require('chart.js/auto');
// Date adapter for Chart.js time scale (uses moment.js)
require('chartjs-adapter-moment');

angular.module('jsPDF', []);

angular.module('admin', ['ui.bootstrap', 'angular-clipboard']);
angular.module('console', ['ui.bootstrap']);
angular.module('history', ['ui.bootstrap', 'infinite-scroll']);
angular.module('activity', ['ui.bootstrap', 'infinite-scroll']);
angular.module('login', []);
angular.module('passwords', []);
angular.module('createReferrals', ['ui.bootstrap', 'angularFileUpload']);
angular.module('viewReferrals', ['ui.bootstrap', 'angularFileUpload']);
angular.module('editUserModals', ['ui.bootstrap']);
angular.module('modals', ['ui.bootstrap']);
angular.module('pdf', ['jsPDF']);
angular.module('registration', []);
angular.module('unsavedChanges', []);
angular.module('dentalLinksServices', ['ngResource']);
angular.module('dentalLinksDirectives', ['angularFileUpload']);
angular.module('error', []);
angular.module('unsubscribe', []);
angular.module('guest', []);

require('./controllers/admin/adminController.js');
require('./controllers/admin/adminInviteController.js');
require('./controllers/admin/adminPracticeController.js');
require('./controllers/admin/adminUsersController.js');
require('./controllers/upgradeModalController.js');
require('./controllers/insightsController.js');
require('./controllers/console/consoleController.js');
require('./controllers/console/practiceConsoleController.js');
require('./controllers/console/reportsConsoleController.js');
require('./controllers/console/sentEmailModalController.js');
require('./controllers/modals/brandingPreviewModalController.js');
require('./controllers/modals/demoReferralModalController.js');
require('./controllers/modals/editUserModals.js');
require('./controllers/modals/modalsController.js');
require('./controllers/createReferralsController.js');
require('./controllers/createGuestReferralsController.js');
require('./controllers/errorController.js');
require('./controllers/historyController.js');
require('./controllers/activityController.js');
require('./controllers/loginController.js');
require('./controllers/guestOrLoginController.js');
require('./controllers/passwordsController.js');
require('./controllers/preRegistrationController.js');
require('./controllers/registrationController.js');
require('./controllers/confirmEmailController.js');
require('./controllers/reviewReferralsController.js');
require('./controllers/savePasswordsController.js');
require('./controllers/viewReferralsController.js');
require('./controllers/unsubscribeController.js');
require('./controllers/activateGuestReferralController.js');
require('./directives/directives.js');
require('./directives/referral/findPatientDirective.js');
require('./directives/referral/findPracticeDirective.js');
require('./directives/referral/fromProviderDirective.js');
require('./directives/referral/toProviderDirective.js');
require('./directives/referral/procedureBlockDirective.js');
require('./directives/referral/statusSelectorDirective.js');
require('./services/fileTypes.js');
require('./services/jsPdfLoader.js');
require('./services/pdfDataPrep.js');
require('./services/pdfImageHandler.js');
require('./services/pdfComponents.js');
require('./services/pdf.js');
require('./services/referralHelper.js');
require('./services/referralAutosave.js');
require('./services/consoleHelper.js');
require('./services/services.js');
require('./services/subscriptionService.js');
require('./services/upgradeModal.js');
require('./services/statesData.js');
require('./services/postOpReminderService.js');
require('./services/authGuard.js');
require('./services/uploadService.js');
require('./services/cbctValidationService.js');
require('./services/cbctUploadService.js');
require('./services/cbctStripService.js');
require('./services/unsavedChanges.js');
require('./services/impersonation.js');

angular.module('dentalLinks', [
    'ui.router',
    'ui.router.state.events',
    'ui.router.tabs',
    'ngCookies',
    'admin',
    'console',
    'history',
    'activity',
    'login',
    'passwords',
    'createReferrals',
    'viewReferrals',
    'editUserModals',
    'modals',
    'pdf',
    'registration',
    'unsavedChanges',
    'dentalLinksServices',
    'dentalLinksDirectives',
    'ui.mask',
    'ui.validate',
    'localization',
    'error',
    'unsubscribe',
    'guest',
    'isteven-multi-select',
    'angularFileUpload',
    'dentalLinksPartials',
    'angularCSS',
    'ngSanitize'
]);

require('./directives/referral/findPatientController.js');
require('./directives/referral/findPracticeController.js');
require('./directives/referral/fromProviderController.js');
require('./directives/referral/toProviderController.js');
require('./directives/referral/procedureBlockController.js');
require('./directives/referral/statusSelectorController.js');
require('./controllers/attachmentsController.js');
require('./controllers/navController.js');
require('./controllers/account_setup_actions.js');
require('./controllers/teethController.js');
require('./controllers/notesController.js');
require('./controllers/rolesSelectorController.js');
require('./controllers/userAddressesController.js');
require('./controllers/notificationAreaController.js');
require('./controllers/offerConvertGuestController.js');
require('./controllers/supportController.js');
require('./services/imageUtils.js');
require('./services/logger.js');
require('./services/authInterceptor.js');
require('./services/emailSuppressionWarning.js');
require('./services/trialExpiryWarning.js');
require('./services/confirmDialog.js');
require('./filters/fullAddress.js');
require('./filters/destinationName.js');
require('./filters/invitedDestination.js');
require('./filters/cbctFileSize.js');

require('./app.js');
